import { createTheme } from './createTheme'

export default (assets) =>
  createTheme({
    name: 'Educacional',
    assets,
    colors: {
      // brand
      primary: '#6200A8',
      secondary: '#785afd'
    }
  })
